import PropTypes from 'prop-types';

export default {
  title: PropTypes.string,
  message: PropTypes.string,
  theme: PropTypes.string,
};
